const BUCKET_NAME = 'metadata.name';

export default class ThingNameController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        if (!this.thingName) {
            this.thingName = '';
        }
    }

    $onChanges(changes) {
        if (changes.reset) {
            if (!changes.reset.isFirstChange() && changes.reset.currentValue === true) {
                this.resetValues();
            }
        }
    }

    onChange() {
        if (this.thingName.length) {
            this.fillBucket();

            this.pushUpdate(
                this.eventEmitter(
                    {
                        value: this.thingName
                    }
                )
            );
        } else {
            this.clearBucket();
        }
    }

    fillBucket() {
        this.addItemToBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME,
                    value: this.thingName
                }
            })
        );
    }

    clearBucket() {
        this.removeItemFromBucket(
            this.eventEmitter({
                item: {
                    name: BUCKET_NAME
                }
            })
        );
    }

    resetValues() {
        this.thingName = '';

        this.clearBucket();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-name/thing-name.controller.js